import React, {useEffect, useState} from 'react';
import {Box, Button, TablePagination, Typography} from "@mui/material";
import MonthDataList from "./MonthDataList";
import CustomSearch from "../common/CustomSearch";
import SearchComponent from "../searchComponent/SearchComponent";
import {useAppDispatch, useTypedSelector} from "../../store";
import {useFormik} from "formik";
import {clearMonthQuery, clearMonthQueryFilterData, setMonthFilterData} from "../../store/month-data/month-data.slice";
import {useLocation, useNavigate} from "react-router-dom";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import {IGetMonthDataFilter} from "../../store/rtk-api/reconciliations/types";
import CustomDatePicker from "../common/CustomDatePicker";
import {fetchReconciliationExcelFile} from "../../store/reconcilation/reconcilation.action";
import {setClearExcel} from "../../store/reconcilation/reconciliation.slice";


const MonthDataPage = () => {
    //location state
    // @ts-ignore
    const {month} = useLocation().state
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    // Filter actions
    const {query, visit_date, date} = useTypedSelector(state => state.monthData)
    const {addressId} = useTypedSelector(state => state.header)
    const formik = useFormik<IGetMonthDataFilter>({
        enableReinitialize: true,
        initialValues: {
            query: query || '',
            visit_date: visit_date || 'all'
        },
        onSubmit: (values) => {
            dispatch(setMonthFilterData({
                page: undefined,
                query: values.query,
                visit_date: values.visit_date
            }))
        }
    })
    const {handleChange, values, handleSubmit, setFieldValue} = formik
    const handleClear = () => {
        dispatch(clearMonthQueryFilterData())
        setFieldValue('query', '')
    }
    // Pagination actions
    const {monthDataCount} = useTypedSelector(state => state.calendar)
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(20);
    const [excelUrl, setExcelUrl] = useState('')
    useEffect(() => {
        dispatch(setMonthFilterData({page: page + 1}))
        dispatch(clearMonthQuery())
    }, [page])
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
    };
    const handleChangeRowsPerPage = (event: React.ChangeEvent<HTMLInputElement>) => {
        setRowsPerPage(parseInt(event.target.value, 20));
        setPage(0);
    };
    const {data} = useTypedSelector(state => state.reconciliation)

    // const handleExportToExcel = () => {
    //      getMonthReconciliationsExcel({addressId, date})
    //     dispatch(fetchReconciliationExcelFile({addressId, date}))
    //
    // }

    const startDownload = (file: any, fileName: any) => {
        const url = window.URL.createObjectURL(new Blob([file]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);

    }

    // useEffect(() => {
    //     if (data) {
    //         startDownload(data, "сверка.xlsx")
    //         dispatch(setClearExcel())
    //     }
    // }, [data])

    useEffect(() => {
        if (addressId && date) {
            setExcelUrl(`https://api.docfinder.kz/api/adm/total-reconciliations/${addressId}/month/${date}/export`)
        }
    }, [addressId, date])


    const children = (
        <Box
            sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                width: "100%",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <div style={{marginRight: "20px"}}>
                    <CustomSearch
                        field={"query"}
                        handleChange={handleChange}
                        placeholder={"Врач, услуга, процедура"}
                        width={"300px"}
                        name={"query"}
                        values={values}
                        handleSubmit={handleSubmit}
                        handleClear={handleClear}
                    />
                </div>
                <div style={{display: "flex", alignItems: "center", gap: "2px", marginRight: "30px"}}>
                    Дата:{" "}
                    <CustomDatePicker
                        handleSubmit={handleSubmit}
                        field={"visit_date"}
                        setFieldValue={setFieldValue}
                    />
                </div>
                <div style={{display: "flex", alignItems: "center"}}>
                    <a href={excelUrl} target={"_blank"} style={{textDecoration:"none"}}>
                        <Button
                            // onClick={handleExportToExcel}
                            variant={"contained"}>Выгрузить в excel</Button>
                    </a>
                </div>
            </div>

            <div>
                <TablePagination
                    rowsPerPageOptions={[]}
                    component="div"
                    count={
                        monthDataCount ||
                        0}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage=""
                    sx={{marginBottom: "10px"}}
                />
            </div>
        </Box>
    )
    // console.log(monthReconciliationsExcel)

    return (
        <>
            <Box sx={{
                width: "100%",
                borderBottom: 1,
                borderColor: 'divider',
                p: "15px",
                display: "flex",
                alignItems: "center",
                gap: "15px"
            }}>
                <Button variant={"contained"}
                        sx={{height: "40px", borderRadius: "2px", border: "none", backgroundColor: "secondary.main"}}
                        onClick={() => navigate(-1)}>
                    <ArrowBackIcon/>
                </Button>
                <Typography sx={{
                    fontSize: "18px",
                    fontWeight: "500",
                    textTransform: "capitalize",
                    color: "#000"
                }}>{`${month}`}</Typography>
            </Box>
            <SearchComponent children={children}/>
            {/*<IsError isError={isError}/>*/}
            {/*{isLoading&&<CircularProgress/>}*/}
            <MonthDataList/>
        </>
    );
};

export default MonthDataPage;
